import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NodeApiService} from '../network/online/node/node-api.service';
import {Observable} from 'rxjs';
import {PeerConnectionApiService} from '../peer-connection/peer-connection-api.service';
import {RoutingGroupApiService} from '../routing-group/routing-group-api.service';
import {RoutingServersSettingsApiService} from '../routing-servers/routing-servers-settings-api.service';
import {UrlQueryService} from '../../common/url-query/url-query.service';
import _ from 'lodash';
import {CustomersApiService} from '../customers/customers-api.service';
import {FileSaverService} from 'ngx-filesaver';
import {CallStudioApiService} from "../settings/call-flow-configurations/call-studio/call-studio-api.service";


@Injectable({
  providedIn: 'root'
})
export class CallsApiService {

  constructor( private http: HttpClient,
               private nodesApiService: NodeApiService,
               private peerConnectionsApiService: PeerConnectionApiService,
               private routingGroupApiService: RoutingGroupApiService,
               private serversApiService: RoutingServersSettingsApiService,
               private customersApiService: CustomersApiService,
               private policyStudioApiService: CallStudioApiService,
               private fileSaver: FileSaverService){}

  getCallsSummary(parameters): Observable<any> {
    const newParameters = this.buildCallsFilter(parameters);

    const uri = UrlQueryService.addQueryParameters('calls', newParameters);
    return this.http.get(uri);
  }

  getCallDetails(sessionKey): Observable<any> {
    const uri = 'calls/' + sessionKey;

    return this.http.get(uri);
  }

  getCallFilterExternalData(): Promise<any> {
    return Promise.all([
      this.nodesApiService.getNodes(),
      this.peerConnectionsApiService.getPCons(),
      this.routingGroupApiService.getGroupsSlim(),
      this.serversApiService.getRoutingServers().toPromise(),
      this.customersApiService.getCustomers().toPromise(),
      this.policyStudioApiService.getCallsNames().toPromise()
    ]).then(data => {
      return {
        nodes: data[0],
        pcons: data[1].elements,
        routingRules: this.getRulesWithGroupName(data[2]),
        routers: data[3],
        customers: data[4].elements,
        policyStudios: data[5]
      };
    });
  }

  prepareDate(nodes, pcons, routingRules, routers): any {
    return {
      nodes,
      pcons: pcons.elements,
      routingRules: this.getRulesWithGroupName(routingRules),
      routers
    };
  }

  private buildCallsFilter(parameters): void {
    const filter: any = {
      srcUriBeforeManipulation : {operator: ':', value: this.addQuotaIfNeeded(parameters.search.srcUriBeforeManipulation)},
      dstUriBeforeManipulation : {operator: ':', value: this.addQuotaIfNeeded(parameters.search.dstUriBeforeManipulation)},
      sessionId : {operator: '=', value: this.addQuotaIfNeeded(parameters.search.sessionId)},
      incomingNodeId : {operator: '=', value: parameters.search.incomingNodeId},
      incommingPconId : {operator: '=', value: parameters.search.incommingPconId},
      incomingCustomerId : {operator: '=', value: parameters.search.incomingCustomerId},
      outgoingNodeId : {operator: '=', value: parameters.search.outgoingNodeId},
      outgoingPconId : {operator: '=', value: parameters.search.outgoingPconId},
      outgoingCustomerId : {operator: '=', value: parameters.search.outgoingCustomerId},
      routingRuleId : {operator: '=', value: parameters.search.routingRuleId},
      policyStudioId: {operator: '=', value: parameters.search.policyStudioId},
      sipTerminationReason : {operator: '=', value: this.addQuotaIfNeeded(parameters.search.sipTerminationReason)},
      regExpSearch : {operator: '=', value: parameters.search.regExpSearch},
    };

    if (parameters.search.enableDate) {
      filter.startTime = {operator: '=', value: parameters.search.date.startDate.toISOString()};
      filter.endTime = {operator: '=', value: parameters.search.date.endDate.toISOString()};
    }

    parameters.filter = filter;
    delete parameters.search;

    return parameters;
  }

  private getRulesWithGroupName(groups): void {
    groups.forEach(group => group.routingRules.forEach(rr => rr.groupName = group.name));
    const groupsRules: any =  [];
    groups.forEach(group => {groupsRules.push(group.routingRules); });
    return [].concat.apply([], groupsRules);
  }

  private addQuotaIfNeeded(searchString): string {
    const quota = '\'';

    return (!_.isNil(searchString) && searchString !== '')
      ? quota + searchString + quota : searchString;
  }

  exportCalls(parameters): void {
    const newParameters = this.buildCallsFilter(parameters);

    const uri = UrlQueryService.addQueryParameters('calls/export', newParameters);
    this.http.get(uri, { responseType: 'blob' }).subscribe(data => {

      const fileType = {type: 'text/csv'};
      const blob = new Blob([ data ], fileType);
      this.fileSaver.save(blob, 'calls.csv');
    });
  }

}




